export default __webpack_public_path__ + "static/media/example_img_1_7_1.7575eb30.png";